/**
 * Parallax section
 *
 * Measures every stacking block (_parallax-block.liquid) and writes its height
 * to --parallax-block-height on the block. The block's sticky offset is
 * min(0, viewport - height): a block that is taller than the viewport (mobile)
 * first scrolls up until its text and button are in view and only then pins,
 * while the next block slides over it. Blocks that fit stick at the top.
 */
class ParallaxSection extends HTMLElement {
  connectedCallback() {
    this.blocks = this.querySelectorAll('[data-parallax-block]');
    if (!this.blocks.length) return;

    // Fires once on observe and again whenever the content reflows (resize, fonts, images)
    this.resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        entry.target.style.setProperty('--parallax-block-height', `${entry.target.offsetHeight}px`);
      }
    });
    this.blocks.forEach(block => this.resizeObserver.observe(block));
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }
}

if (!customElements.get('parallax-section')) {
  customElements.define('parallax-section', ParallaxSection);
}
